import React, { useCallback, useEffect, useState } from 'react'
import { Badge, Button, Card, Form } from '@themesberg/react-bootstrap'
import { useCookies } from 'react-cookie'
import { toast } from 'react-toastify'
import { getLotoRuleSet, setLotoRuleSet } from '../../../../controller/api/__loto__/result'

const RULE_SET_LABELS = {
  SET_A: 'Tây Ninh',
  SET_B: 'Bến Tre',
  SET_KG: 'Kiên Giang',
}

const labelFor = (id) => RULE_SET_LABELS[id] || id

export const LotoRuleSetSelect = () => {
  const [cookies] = useCookies(['lottmekong'])
  const [loaded, setLoaded] = useState(false)
  const [saving, setSaving] = useState(false)
  const [ruleSet, setRuleSet] = useState('')
  const [draft, setDraft] = useState('')
  const [options, setOptions] = useState(['SET_A', 'SET_B', 'SET_KG'])

  const load = useCallback(async () => {
    setLoaded(false)
    const resp = await getLotoRuleSet(cookies.lottmekong)
    if (resp && resp.ruleSet) {
      setRuleSet(resp.ruleSet)
      setDraft(resp.ruleSet)
      if (Array.isArray(resp.options) && resp.options.length > 0) {
        setOptions(resp.options)
      }
    }
    setLoaded(true)
  }, [cookies.lottmekong])

  useEffect(() => {
    load()
  }, [load])

  const onSave = async () => {
    if (!draft || draft === ruleSet) {
      return
    }
    if (!window.confirm(`Đổi bộ luật chơi sang ${labelFor(draft)}? Thay đổi áp dụng ngay cho mua vé và tính thưởng.`)) {
      setDraft(ruleSet)
      return
    }
    setSaving(true)
    const resp = await setLotoRuleSet(cookies.lottmekong, draft)
    if (resp && resp.ruleSet) {
      setRuleSet(resp.ruleSet)
      setDraft(resp.ruleSet)
      if (Array.isArray(resp.options) && resp.options.length > 0) {
        setOptions(resp.options)
      }
      toast.success(`Đã chọn ${labelFor(resp.ruleSet)}`)
    } else {
      toast.error('Không thể đổi bộ luật chơi. Chỉ super admin được phép.')
      setDraft(ruleSet)
    }
    setSaving(false)
  }

  const busy = !loaded || saving

  return (
    <Card border="light" className="shadow-sm">
      <Card.Header>
        <h6 className="mb-0">Bộ luật chơi</h6>
        <div className="small text-muted mt-1">Chỉ super admin được đổi bộ luật chơi đang chạy</div>
      </Card.Header>
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span className="text-muted">Đang dùng</span>
          <Badge bg="info">{loaded ? labelFor(ruleSet) : 'Đang tải...'}</Badge>
        </div>
        <Form.Select
          value={draft}
          disabled={busy}
          onChange={(evt) => setDraft(evt.target.value)}
        >
          {options.map((id) => (
            <option key={id} value={id}>{labelFor(id)}</option>
          ))}
        </Form.Select>
        <Button
          className="mt-3"
          variant="primary"
          size="sm"
          disabled={busy || !draft || draft === ruleSet}
          onClick={onSave}
        >
          {saving ? 'Đang lưu...' : 'Lưu bộ luật chơi'}
        </Button>
      </Card.Body>
    </Card>
  )
}
